import { H3 } from '@thisisdevelopment/akzonobel-core';
import { Styles } from './styled';

export interface SectionProps {
  title?: string;
  text?: string;
  linkLabel?: string;
  url?: string;
}

export function Section({ title, text, linkLabel, url }: SectionProps) {
  return (
    <Styles>
      {title && <H3>{title}</H3>}
      {text && <p dangerouslySetInnerHTML={{ __html: text }} />}
      {linkLabel && url && <a href={url}>{linkLabel}</a>}
    </Styles>
  );
}
